import type { FunctionComponent, PropsWithChildren } from 'react';
import classNames from 'classnames';
import { IFormField } from '../../../../../interfaces';
import { isFieldState } from '../../../../../interfaces/IBaseField';
import { FieldError } from '../../../Shared';
import { FF_CONTAINER, FF_INPUT } from './formFieldTestIds';
import * as styles from './FormField.module.css';

const FormField: FunctionComponent<PropsWithChildren<IFormField>> = ({
  location,
  label = '',
  id = '',
  placeholder = '',
  dataRecurly = '',
  children,
  fieldStatus,
  type,
  pattern,
  labelClassName,
  onFocus,
}) => {
  const inputInvalidStyles = fieldStatus.hasError ? ` ${styles.ffInvalid}` : '';
  const inputStyles = `${styles.ffInput}${inputInvalidStyles}`;

  let labelStyles = location === 'GTB' ? styles.ffContainerGtb : styles.ffContainer;
  const invalidLabelStyles = fieldStatus.hasError ? ' ffInvalid' : '';
  labelStyles = `${labelStyles}${invalidLabelStyles}`;

  return (
    <label
      data-testid={FF_CONTAINER}
      htmlFor={id}
      className={classNames(labelStyles, labelClassName)}
      data-e2e={id}
    >
      {label}
      <>
        {children || (
          <input
            className={inputStyles}
            data-testid={FF_INPUT}
            id={id}
            data-recurly={dataRecurly}
            placeholder={placeholder}
            onChange={fieldStatus.changeHandler}
            onBlur={fieldStatus.blurHandler}
            onFocus={() => (onFocus ? onFocus() : fieldStatus.focusHandler?.())}
            value={isFieldState(fieldStatus) ? fieldStatus.value : undefined}
            type={type}
            pattern={pattern}
          />
        )}
        {fieldStatus.hasError && <FieldError errorMsg={fieldStatus.errorMsg} />}
      </>
    </label>
  );
};

export default FormField;
